<template>
  <div class="actCalendar pos-r" v-if="actcalendar.list && actcalendar.list.length">
    <div class="actImg ml11 mr11">
      <img :src="actcalendar.bgurl" @click="actcalendarHandle" alt="" class="w-100 h-100 of-c radius-8px" />
    </div>
    <div class="pos-a l0 r0 actDetail scroll-x">
      <swiper
        :options="actseckillSwiper"
        class="flex ai-c fw-n h-100 pl16 pr16"
        id="swiperActseckill"
      >
        <swiper-slide
          class="h-100 flex-s pos-r"
          v-for="(item, index) of actcalendar.list"
          :key="index"
        >
          <img :src="item.img_path" @click="actcalendarHandle(index)" alt="" class="h-100 w-100 of-c radius-8px" />
          <div
            :path="item.ad_target + (item.ad_target.indexOf('?') >= 0 ? '&' : '?') + 'sorce=17'"
            :username="'gh_5d4bb8e18b8b'"
            class="slide_cl_xcx"
            v-if="isWx && (item.ad_type == 7 || item.ad_type == 8)"
          ></div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import { isWeixin } from '../../../assets/common/js/config'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'
import Vue from 'vue'

Vue.use(VueAwesomeSwiper /* { default global options } */)

export default {
  props: {
    actcalendar: {
      type: Object,
      default: function () {
        return {}
      }
    },
    /** 埋点 flowArea 前缀，如 bannerZone */
    flow_area_prefix: {
      type: String,
      default: 'ACTCALENDAR'
    },
  },
  data() {
    var that = this
    return {
      isWx: isWeixin() ? 1 : 0,
      actseckillSwiper: {
        observer: true,
        observeParents: true,
        freeMode: true,
        slidesPerView: 1.7023,
        spaceBetween: 7,
        pagination: {
          el: '#actseckillSwiperPagination',
          type: 'bullets'
        }
      }
    }
  },
  methods: {
    actcalendarHandle(index) {
      if (typeof index == 'number') {
        this.$emit('banner-click', this.actcalendar.list[index], index, this.flow_area_prefix +'-' + (index + 1))
      } else {
        this.$emit('banner-click', this.actcalendar, 0, this.flow_area_prefix)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.actCalendar {
  height: 1.49rem;
}
.actImg {
  height: 100%;
  border-radius: 0.1rem;
}
.actDetail {
  height: 1.04rem;
  bottom: 0.08rem;
  img {
    border-radius: 0.1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/homepage/components/actCalendar.vue